import React from 'react';
import CMSTextVisual from '../../../textVisual';
import CMSQuote from '../../../quote';
import CMSDownload from '../../../download';
import DynamicTeaser from '../../../dynamicTeaser';

const dynamicComponents = {
  ContentfulContentTextVisualWrapper: CMSTextVisual,
  ContentfulContentQuote: CMSQuote,
  ContentfulContentDownloadWrapper: CMSDownload,
  ContentfulContentDynamicTeaser: DynamicTeaser,
};

export const renderDynamicComponents = (components, lang) => {
  return components.map((component, index) => {
    if (!component.internal) return null;
    const DynamicComponent = dynamicComponents[component.internal.type];
    return DynamicComponent ? (
      <DynamicComponent key={index} lang={lang} {...component} />
    ) : null;
  });
};
